import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import StringModel from '@/views/Language/models/string'
import StringAttachmentModel from '@/views/Language/models/stringAttachment'
import AttachmentModel from '@/views/Attachment/model/attachment'

import RichTextViewer from '@/_components/richText/viewer/viewer.vue'
import Attachment from '@/components/Attachment/Attachment.vue'
import Translation from '@/views/Language/components/translation/translation.vue'
import AttachmentDropzone from '@/views/Attachment/components/dropzone/dropzone.vue'
@Component({
    components: { Attachment, RichTextViewer, Translation, AttachmentDropzone },
})
export default class String extends Mixins<MixinInterface>() {
    @VModel({ required: true }) string!: StringModel
    @Prop({ required: true }) strings!: Array<StringModel>

    // Attachments
    async showAttachment(attachment: StringAttachmentModel) {
        if (this.string) {
            let res: any = await attachment.showLog(attachment, {})

            if (res && res.delete) {
                let index = this.string.attachments.findIndex((item) => item._id == attachment._id)
                this.string.attachments.splice(index, 1)

                await this.string.get()
            }
        }
    }

    loadingAttachments = false
    async onGetAttachments(attachments: Array<any>) {
        if (this.string) {
            this.loadingAttachments = true
            await this.string.postAttachments(attachments)
            this.loadingAttachments = false
        }
    }

    async pastStringAttachment(event) {
        if (this.isSuperuser) {
            AttachmentModel.retrieveImageFromClipboardAsBlob(event, async (imageDataBase64) => {
                this.loadingAttachments = true
                let arr = [imageDataBase64]
                let attachments = await AttachmentModel.uploadFiles(arr)
                await this.string.postAttachments(attachments)
                this.loadingAttachments = false
            })
        }
    }

    descriptionFull = false

    // DELETE
    deleting = false
    async toggleDelete() {
        this.deleting = true
        await this.string.delete()
        this.deleting = false
    }
}
